"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var utils_1 = require("../../utils");
exports.default = (function (transparent48v2) { return function (data) {
    return [0x48, 5, 11, transparent48v2.virtual.msgId].map(function (val) { return utils_1.decToHex(val); });
}; });



// WEBPACK FOOTER //
// ./src/transparent48v2/encode/11.ts